module.exports = __webpack_public_path__ + "img/symbol_2.1b78c6c9.png";